export default __webpack_public_path__ + "media/images/pp_logo_white-331ae154ab180f0565da5409bfd01a67.png";